import React, { useCallback, useEffect, useRef, useState } from "react";
import ListPageHeader from "../../../utilities/ListPageHeader";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import { AppBar, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Icon, IconButton, MenuItem, Select as MuiSelect, Stack, Switch, TextField, Toolbar, Tooltip, Typography } from "@mui/material";
import customStyles from "app/shared-components/SelectCustomStyle";
import Select from "react-select";
import CustomDatePicker from "../../../utilities/CustomDatePicker";
import moment from "moment";
import AgGridTable from "../../../utilities/AgGridTable";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import OAuthService from "src/app/auth/services/oAuthService";
import AddLinkToCustomer from "./AddLinkToCustomer";
import jwtDecode from "jwt-decode";
import ViewLinkToCustomer from "./ViewLinkToCustomer";
import { useNavigate } from "react-router-dom";

const LinkToCustomer = () => {

    // const DummyData = [{
    //     custNum: "30001", companyName: "KHALAIFAT COMPANY", orderType: "PROJECT", paymentTermCode: "P00012", paymentTermDesc: "50% off Proforma and 50% 30days later after delivery",
    //     creditLimit: "-", creditBalance: "-", booking: false, releasing: false, validFrom: "05-09-2023", validTo: "05-10-2023", approved: true
    // }]
    const gridRef = useRef()
    const childRef = useRef();
    const navigate = useNavigate();
    const [gridApi, setGridApi] = useState();
    const [successMsg, setSuccessMsg] = useState();
    const [snackState, setSnackState] = useState(false);
    const [error, setError] = useState();
    const [customer, setCustomer] = useState();
    // const [customerOptions, setCustomerOptions] = useState([]);
    const [selectedSize, setSelectedSize] = useState(10);
    const [fromError, setFromError] = useState();
    const [toError, setToError] = useState();
    const [toDate, setToDate] = useState();
    const [addClick, setAddClick] = useState(true);
    const [fromDate, setFromDate] = useState();
    const [selectedRows, setSelectedRows] = useState([]);
    const [rowData, setRowData] = useState([]);
    const [formOpen, setFormOpen] = useState(false);
    const [saveDisable, setSaveDisable] = useState(false);
    const [expandRowData, setExpandRowData] = useState("collapse");
    const token = localStorage.getItem("token") && jwtDecode(localStorage.getItem("token"));

    const checkBooking = (props) => {
        return (props.value || !props.value) && <Switch  size="small" checked={props.value} />
    }

    const checkReleasing = (props) => {
        return (props.value || !props.value) && <Switch size="small" checked={props.value} />
    }

    const checkApprove = (props) => {
        return (props.value || !props.value) && <Switch size="small" checked={props.value} />
    }

    const [columnDefs, setColumnDefs] = useState([
        {
            field: 'custNum', headerName: 'Partner Number', minWidth: 150,
            cellClassRules: {
                'show-cell': 'value !== undefined'
            },
            rowSpan: function (params) {
                if (params?.data?.custNum !== undefined) {
                    return params?.data?.custNumber;
                } else {
                    return 1;
                }
            }
        },
        {
            field: 'companyName', headerName: 'Name', minWidth: 150,
            cellClassRules: {
                'show-cell': 'value !== undefined'
            },
            rowSpan: function (params) {
                if (params?.data?.companyName !== undefined) {
                    return params?.data?.custNumber;
                } else {
                    return 1;
                }
            }
        },
        { field: 'orderType', headerName: 'Order Type', minWidth: 150, },
        { field: 'paymentTermCode', headerName: 'Payment Term', minWidth: 230, },
        { field: 'paymentTermDesc', headerName: 'Description', minWidth: 250, },
        { field: 'creditLimit', headerName: 'Credit Limit', minWidth: 250, },
        { field: 'creditBalance', headerName: 'Credit Balance', minWidth: 250, },
        { field: 'booking', headerName: 'Booking', minWidth: 250, cellRenderer: checkBooking },
        { field: 'releasing', headerName: 'Releasing', minWidth: 250, cellRenderer: checkReleasing },
        { field: 'validFrom', headerName: 'Valid From', minWidth: 250, },
        { field: 'validTo', headerName: 'Valid To', minWidth: 250, },
        { field: 'approved', headerName: 'Approve', minWidth: 250, cellRenderer: checkApprove },
        { field: 'view', headerName: 'View', minWidth: 250, cellRenderer: ViewLinkToCustomer },
    ]);

    const LinkCustomerUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.paymentTerm + '/linkToCustomer'}`;

    const onPageSizeChanged = useCallback((e) => {
        setSelectedSize(e.target.value);
        var value = e.target.value;
        gridRef.current.api.paginationSetPageSize(value);
    }, []);

    const loadLinkToCustomerData = async () => {
        const obj = {
            "customerName": customer,
            "startDate": fromDate,
            "endDate": toDate
        }
        const list = await OAuthService.addData(LinkCustomerUrl + `/search`, obj);

        if (expandRowData === 'collapse') {


            if (list?.data) {

                let paymentTermData = list?.data.map((data) => {
                    if (data) {
                        data.custNum = data?.company?.id ? data?.company?.id : '';
                        data.paymentTermCode = data?.paymentTerm?.code;
                        data.paymentTermDesc = data?.paymentTerm?.paymentCondition;
                    }
                    return data
                }).filter((data) => data !== undefined && data !== '' && data !== null)
                setRowData(paymentTermData)
            }
        }
        else {
            let LCNumberCount = []
            let expandList = list?.data.map((data) => {
                if (data) {
                    data.custNum = data?.company?.id ? data?.company?.id : '';
                    data.paymentTermCode = data?.paymentTerm?.code;
                    data.paymentTermDesc = data?.paymentTerm?.paymentCondition;
                    if (LCNumberCount[data?.company?.id] || LCNumberCount[data?.company?.id] >= 1) {
                        LCNumberCount[data?.company?.id] = LCNumberCount[data?.company?.id] + 1;
                        data.custNum = undefined;
                        data.companyName = undefined;

                    } else {
                        LCNumberCount[data.custNum] = 1;
                    }
                }
                return data;
            }).filter((data) => data !== undefined && data !== '' && data !== null)
            expandList = expandList?.map((data) => {
                data.custNumber = LCNumberCount[data.custNum]
                return data;
            })
            setRowData(expandList)
        }
    };

    useEffect(() => {
        loadLinkToCustomerData()
    }, [expandRowData])

    const handleGoToPaymentTerm = () => {
        navigate('/payment-terms')
    }

    const LinkToCustomerInputFields = () => {
        return <>
        <Tooltip title={"Payment Terms"}>
                <Button
                    variant="contained"
                    color="warning"
                    style={{ marginLeft: "3px" }}
                    onClick={handleGoToPaymentTerm}
                >
                    <FuseSvgIcon>heroicons-solid:cash</FuseSvgIcon>
                </Button>
            </Tooltip>
            <Tooltip title={"Add Link To Partner"}>
                <Button
                    variant="contained"
                    color="warning"
                    style={{ marginLeft: "3px" }}
                    onClick={handleAddButton}
                >
                    <FuseSvgIcon>heroicons-solid:plus-circle</FuseSvgIcon>
                </Button>
            </Tooltip>

            {(expandRowData === "collapse") ?
                < Tooltip title={"Expand Proforma Invoice"}>
                    <Button
                        variant="contained"
                        color="warning"
                        style={{ marginLeft: "4px" }}
                        onClick={() => setExpandRowData('expand')}
                    >
                        <FuseSvgIcon>material-outline:unfold_more</FuseSvgIcon>
                    </Button>
                </Tooltip>
                :

                <Tooltip title={"Collapse Proforma Invoice"}>
                    <Button
                        variant="contained"
                        color="warning"
                        style={{ marginLeft: "4px" }}
                        onClick={() => {setExpandRowData('collapse');setSelectedRows([])}}
                    >
                        <FuseSvgIcon>material-outline:unfold_less</FuseSvgIcon>
                    </Button>
                </Tooltip>
            }
        </>
    }

    const handleSave = () => {
        const childelement = childRef.current;
        const submitData = childelement.handleSubmit();
        submitData.then((val) => {
            if (val) {
                handleFormClose()
                loadLinkToCustomerData();
            }
        })
    }

    useEffect(() => {
        handleSuccessMsg();
    }, []);

    const handleSuccessMsg = (msg) => {
        if (msg) {
            setSuccessMsg(msg)
            setSnackState(true)
        } else {
            setSnackState(false)
        }
    }

    useEffect(() => {
        loadLinkToCustomerData()
    }, [fromDate, toDate])

    const handleFromDateChange = (value) => {
        setFromDate(value === null ? null : moment(value).format('YYYY-MM-DD'));
    }

    const handleToDateChange = async (value) => {
        const endDate = value === null ? null : moment(value).format('YYYY-MM-DD');
        setToDate(endDate);
    }

    const handleEditButton = () => {
        setFormOpen(true)
        setAddClick(false);
    }

    const handleAddButton = () => {
        setFormOpen(true);
        setAddClick(true);
    }

    const handleFormClose = () => {
        setFormOpen(false);
    }

    const onGridReady = (params) => {
        setGridApi(params.api);
        loadLinkToCustomerData();
    };

    const onSelectionChanged = (params) => {
        setSelectedRows(params.api.getSelectedRows());
    }

    const onRowDoubleClicked = (params) => {
        handleEditButton(params)
    }

    const saveDisabled = (st) => {
        setSaveDisable(st)
    }

    return (
        <>
            <ListPageHeader
                pageName={"Payment Terms - Link To Partner"}
                componentName="Payment Terms - Link To Partner"
                editDisable={(selectedRows && selectedRows.length > 0) ? false : true}
                headerInputFields={LinkToCustomerInputFields()}
                gridRef={gridRef}
                successMsg={successMsg}
                snackState={snackState}
                showPaginationDropdown={false}
            />

            <Stack direction={'row'} className="mb-10 md:px-16 self-end ">
                <div className="flex flex-row">
                    <div className="flex flex-row justify-between items-baseline">
                        {/* <FormControl className={"flex"} size="small">
                            <label className="pt-12 min-w-fit">Page Size</label>
                            <MuiSelect onChange={onPageSizeChanged} className='ml-5 h-fit min-w-[150px]' value={selectedSize} id="page-size"
                                // native={true}
                                inputProps={{
                                    sx: { 'padding': '10px' },
                                }}
                            >
                                <MenuItem value="10">10</MenuItem>
                                <MenuItem value="20">20</MenuItem>
                                <MenuItem value="50">50</MenuItem>
                                <MenuItem value="100">100</MenuItem>
                            </MuiSelect>
                        </FormControl> */}

                        <Stack className="ml-10">
                            <label className="min-w-fit">From </label>
                            <div className="grid">
                                <CustomDatePicker
                                    className="w-[150px] h-[20px]"
                                    format={'dd-MM-yyyy'}
                                    name={'fromDate'}
                                    value={fromDate}
                                    maxDate={new Date(toDate)}
                                    handleChange={handleFromDateChange}
                                    views={['year', 'month', 'day']}
                                    componentsProps={{
                                        actionBar: { actions: ["clear"] },
                                    }}
                                    renderInput={(params) => <TextField size="small" InputLabelProps={{
                                    }} {...params} sx={{
                                        backgroundColor: props.viewData && '#8080800f'
                                    }} />}
                                />
                                <p className="text-red">{(fromError && !fromDate) && fromError}</p>
                            </div>
                        </Stack>
                        <Stack className="ml-10">
                            <label className="min-w-fit">To </label>
                            <div className="grid">
                                <CustomDatePicker
                                    className="w-[150px] h-[20px]"
                                    format={'dd-MM-yyyy'}
                                    name={'toDate'}
                                    value={toDate}
                                    minDate={new Date(fromDate)}
                                    views={['year', 'month', 'day']}
                                    handleChange={handleToDateChange}
                                    componentsProps={{
                                        actionBar: { actions: ["clear"] },
                                    }}
                                    renderInput={(params) => <TextField size="small" InputLabelProps={{
                                    }} {...params} sx={{
                                        backgroundColor: props.viewData && '#8080800f'
                                    }} />}
                                />
                                <p className="text-red">{(toError && !toDate) && toError}</p>
                            </div>
                        </Stack>
                    </div>
                </div>
            </Stack>

            <AgGridTable
                rowData={rowData}
                columnDefs={columnDefs}
                onGridReady={onGridReady}
                gridRef={gridRef}
                onSelectionChanged={onSelectionChanged}
                groupCheckBox={false}
                suppressRowTransform={true}
                rowSelection={'single'}
                onRowDoubleClicked={onRowDoubleClicked}
                paginationPageSize={10}
                pagination={true}
                paginationNotAutoPageSize={true}
            />
            <Dialog
                fullWidth={true}
                maxWidth={'md'}
                onClose={handleFormClose}
                open={formOpen}
            // {...other}
            >
                <AppBar position="static">
                    <Toolbar className="flex w-full justify-between">
                        <Typography variant="subtitle1" color="inherit">
                            {(selectedRows && selectedRows.length > 0 && !addClick) ? 'Update Link To Partner' : 'Add Link To Partner'}
                        </Typography>
                        <IconButton
                            onClick={handleFormClose}
                        >
                            <Icon sx={{ color: 'black' }}>close</Icon>
                        </IconButton>
                    </Toolbar>
                </AppBar>
                <DialogContent dividers>
                    <AddLinkToCustomer
                        ref={childRef}
                        saveDisabled={saveDisabled}
                        successMsg={handleSuccessMsg}
                        linkedId={(selectedRows && selectedRows.length > 0 && !addClick) ? selectedRows[0].id : ''}
                    />
                </DialogContent>
                <DialogActions>
                    <Button
                        variant="contained"
                        color="warning"
                        onClick={handleSave}
                    disabled={saveDisable}
                    >
                        <FuseSvgIcon>material-solid:save</FuseSvgIcon>
                    </Button>
                </DialogActions>
            </Dialog>

        </>
    )
}

export default LinkToCustomer

